/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: mQBPD0GccAU

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicUpsellCreditCard.module.css"; // plasmic-import: mQBPD0GccAU/css

import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon

createPlasmicElementProxy;

export type PlasmicUpsellCreditCard__VariantMembers = {};
export type PlasmicUpsellCreditCard__VariantsArgs = {};
type VariantPropType = keyof PlasmicUpsellCreditCard__VariantsArgs;
export const PlasmicUpsellCreditCard__VariantProps =
  new Array<VariantPropType>();

export type PlasmicUpsellCreditCard__ArgsType = {};
type ArgPropType = keyof PlasmicUpsellCreditCard__ArgsType;
export const PlasmicUpsellCreditCard__ArgProps = new Array<ArgPropType>();

export type PlasmicUpsellCreditCard__OverridesType = {
  root?: Flex__<"div">;
  stripeCardElement?: Flex__<"div">;
  text?: Flex__<"div">;
  spinnerContainer?: Flex__<"div">;
  submitButton?: Flex__<typeof Button>;
};

export interface DefaultUpsellCreditCardProps {
  className?: string;
}

const $$ = {};

function PlasmicUpsellCreditCard__RenderFunc(props: {
  variants: PlasmicUpsellCreditCard__VariantsArgs;
  args: PlasmicUpsellCreditCard__ArgsType;
  overrides: PlasmicUpsellCreditCard__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__mqxSq)}>
        <div
          data-plasmic-name={"stripeCardElement"}
          data-plasmic-override={overrides.stripeCardElement}
          className={classNames("all", sty.stripeCardElement)}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames("all", "__wab_text", sty.text)}
          >
            {"STRIPE CARD ELEMENT"}
          </div>
        </div>
        <div className={classNames("all", sty.freeBox__pvAE)}>
          <div
            data-plasmic-name={"spinnerContainer"}
            data-plasmic-override={overrides.spinnerContainer}
            className={classNames("all", sty.spinnerContainer)}
          />

          <Button
            data-plasmic-name={"submitButton"}
            data-plasmic-override={overrides.submitButton}
            className={classNames("__wab_instance", sty.submitButton)}
            endIcon={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__fk8Ai)}
                role={"img"}
              />
            }
            size={"wide"}
            startIcon={
              <ArrowRightSvgIcon
                className={classNames("all", sty.svg__mF8R4)}
                role={"img"}
              />
            }
            type={["primary"]}
          >
            {"Submit"}
          </Button>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "stripeCardElement",
    "text",
    "spinnerContainer",
    "submitButton",
  ],
  stripeCardElement: ["stripeCardElement", "text"],
  text: ["text"],
  spinnerContainer: ["spinnerContainer"],
  submitButton: ["submitButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  stripeCardElement: "div";
  text: "div";
  spinnerContainer: "div";
  submitButton: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicUpsellCreditCard__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicUpsellCreditCard__VariantsArgs;
    args?: PlasmicUpsellCreditCard__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicUpsellCreditCard__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicUpsellCreditCard__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicUpsellCreditCard__ArgProps,
          internalVariantPropNames: PlasmicUpsellCreditCard__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicUpsellCreditCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicUpsellCreditCard";
  } else {
    func.displayName = `PlasmicUpsellCreditCard.${nodeName}`;
  }
  return func;
}

export const PlasmicUpsellCreditCard = Object.assign(
  // Top-level PlasmicUpsellCreditCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    stripeCardElement: makeNodeComponent("stripeCardElement"),
    text: makeNodeComponent("text"),
    spinnerContainer: makeNodeComponent("spinnerContainer"),
    submitButton: makeNodeComponent("submitButton"),

    // Metadata about props expected for PlasmicUpsellCreditCard
    internalVariantProps: PlasmicUpsellCreditCard__VariantProps,
    internalArgProps: PlasmicUpsellCreditCard__ArgProps,
  }
);

export default PlasmicUpsellCreditCard;
/* prettier-ignore-end */
